import React, { useState } from "react";
import { Card, CardHeader, Button, Input, Form } from "reactstrap";

const Pwdchange = (props) => {
  const [password, SetPassword] = useState("");
  const [new_password, SetNewPassword] = useState("");

  return (
    <Form onSubmit={(e) => props.onAdd(e, [password,new_password])}>
      <Card className="p-3">
        <CardHeader>Modifier adresse e-mail</CardHeader>
        <Input className="mb-1"
          placeholder="Mot de passe actuel"
          value={password}
          onChange={(e) => SetPassword(e.target.value)}
        />
        <Input
          placeholder="Nouveau mot de passe"
          value={new_password}
          onChange={(e) => SetNewPassword(e.target.value)}
        />
        <Button className="mt-2">Update</Button>
      </Card>
    </Form>
  );
};

export default Pwdchange;
